<template>
  <v-row dense >
    <v-col cols="12">
      <v-card
        tile
        flat
        :class="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2'"
      >
        <!-- <v-container>
          <v-row dense>
            <v-col cols="12">
              <div class="client-profile-bar py-4">
                <div class="user-profile client-profile">
                  <div class="profile-image">
                    <v-badge
                      avatar
                      bordered
                      overlap
                      :class="
                        $vuetify.theme.dark
                          ? 'blue-darken-2 '
                          : 'white-lighten-2'
                      "
                      icon="mdi-star-outline"
                    >
                      <v-avatar size="59">
                        <v-img src="@/assets/avatar.png"></v-img>
                      </v-avatar>
                    </v-badge>
                  </div>
                  <div class="profile-text trade-master-profile-text">
                    <span><strong>My Trademaster Manager (40%)</strong></span>
                    <span>Hasan billa</span>
                  </div>
                </div>
                <v-btn
                  tile
                  
                  elevation="0"
                  class="text-capitalize btn-account mr-2 ml-n1"
                  color="teal-lighten-1"
                  >View Profile</v-btn
                >
              </div>
            </v-col>
          </v-row>
        </v-container> -->
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      clientInfos: [
        {
          id: 1,
          ClassName: "mb-1",
          title: "Name: ",
          subTitle: "John Doe",
        },
        {
          id: 2,
          ClassName: "mb-1",
          title: "Email: ",
          subTitle: "example@gmail.com",
        },
        {
          id: 3,
          ClassName: "mb-0",
          title: "IB Code: ",
          subTitle: "2342255",
        },
      ],
      lists: [
        {
          id: 1,
          title: "Client ID",
          subTitle: "29737",
          titleAnother: "IB Code",
          subTitleAnother: "29846",
        },
        {
          id: 2,
          title: "Account Number",
          subTitle: "29837",
          titleAnother: "Email Address",
          subTitleAnother: "example@gmail.com",
        },
        {
          id: 3,
          title: "Deposit",
          subTitle: "19372",
          titleAnother: "Withdraw",
          subTitleAnother: "9812",
        },
        {
          id: 4,
          title: "Net Deposit",
          subTitle: "3982",
          titleAnother: "Profit",
          subTitleAnother: "1093",
        },
        {
          id: 5,
          title: "Commission",
          subTitle: "398",
          titleAnother: "Total Earning",
          subTitleAnother: "3981",
        },
        {
          id: 6,
          title: "Size",
          subTitle: "4982",
          titleAnother: "Number Of Accounts",
          subTitleAnother: "31",
        },
      ],
    };
  },
};
</script>
